import { OfferDetailView } from '@today/ui-domain'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { useOfferDetail } from '@/hooks/offers/useOfferDetail'
import { OFFERS_NAMESPACE } from '@/i18n'
import { ForbiddenPage } from '@/pages/errors/Forbidden'

/** `/offers/:offerId` — artifact generation status and the send gate (TO-466 REQ-007..REQ-011). */
export function OfferDetailPage() {
	const { offerId = '' } = useParams()
	return <OfferDetail key={offerId} offerId={offerId} />
}

function OfferDetail({ offerId }: { offerId: string }) {
	const { t } = useTranslation(OFFERS_NAMESPACE)
	const { forbidden, ...props } = useOfferDetail(offerId)
	return forbidden ? <ForbiddenPage /> : <OfferDetailView t={t} {...props} />
}
